import { useBranding } from "../../contexts/branding";
import { LanguageSwitch } from "../../components/language-switch";

export default function Header() {
    const { label, logoUrl } = useBranding();

    return (
        <div className="container padding-top-6">
            <div className="row">
                <div className="col-sm-12 col-md-12">
                    <div className="text-center">
                        <a href="/">
                            <img
                                src={logoUrl}
                                alt={label}
                                className="width-250px"
                            />
                        </a>
                        <div className="text-center m-4">
                            <LanguageSwitch />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
